
import { defineComponent, PropType } from "vue";
import router from "@/routes";
import { useStore } from "vuex";
import MenuItem from "./MenuItem";
import { ExternalRoute } from "../menu/MenuItem";
import { isCirculoTemplate } from "../../../mixins";

export default defineComponent({
  name: "Item",
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    }
  },
  setup(props) {
    const store = useStore();

    /** Change dropdown options list visibility priority if open or closed. */
    function toggleHeaderOptionsState(): void {
      store.dispatch("miscellany_module/toggleHeaderOptionsState");
    }

    async function goToRoute(): Promise<void> {
      if (props.item.disabled) return;

      if (props.item.action) {
        props.item.action();
      } else if (props.item.route instanceof ExternalRoute) {
        window.open(props.item.route.path, props.item.route.target);
        toggleHeaderOptionsState();
      } else if (props.item.route) {
        await router.push({
          name: props.item.route.name,
          params: props.item.route.params
        });
        toggleHeaderOptionsState();
      }
    }

    return {
      goToRoute,
      isCirculoTemplate
    };
  }
});
